// Generate helmet images with team abbreviations
export const getTeamHelmetUrl = (team) => {
  const {
    abbreviation,
    primaryColor = "#1a365d",
    secondaryColor = "#ffffff",
  } = team;

  // Create SVG helmet with team colors and abbreviation
  const helmetSvg = createHelmetSvg(abbreviation, primaryColor, secondaryColor);

  // Convert SVG to data URL
  return `data:image/svg+xml;base64,${btoa(helmetSvg)}`;
};

// Create an SVG helmet with team abbreviation
const createHelmetSvg = (abbreviation, primaryColor, secondaryColor) => {
  return `
    <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <!-- Helmet shape -->
      <ellipse cx="50" cy="55" rx="35" ry="30" fill="${primaryColor}" stroke="${secondaryColor}" stroke-width="2"/>

      <!-- Face mask -->
      <path d="M 25 50 Q 50 45 75 50" stroke="${secondaryColor}" stroke-width="2" fill="none"/>
      <path d="M 30 60 Q 50 55 70 60" stroke="${secondaryColor}" stroke-width="1.5" fill="none"/>

      <!-- Team abbreviation -->
      <text x="50" y="60" text-anchor="middle" font-family="Arial, sans-serif" font-size="16" font-weight="bold" fill="${secondaryColor}">
        ${abbreviation}
      </text>
    </svg>
  `;
};
